import EnvironmentService from "./EnvironmentService";

let environmentService = new EnvironmentService();
let baseAPI = environmentService.getBaseAPI();
let serviceAPI = environmentService.getServiceAPI();

const APIConfig = {
  chatBot: {
    getOTP: serviceAPI + "/v1/hra/login",
    verifyOTP: serviceAPI + "/v1/hra/login/otp",
    nextQuestion: serviceAPI + "/v1/hra/questions/next",
    submitAnswer: serviceAPI + "/v1/hra/questions",
    getallAnswers: serviceAPI + "/v1/hra/questions",
    getEmail: serviceAPI + "/v1/hra/profile",
    undoQuestion: serviceAPI + "/v1/hra/questions/undo",
    getScore: serviceAPI + "/v1/hra/score",
  },
};

export default APIConfig;
